import React, { useMemo } from 'react';
import useChickenDashboardIntervalReqParams from '../../hooks/chickenDashboard/common/useChickenDashboardIntervalReqParams';
import useChickenDashboardAvailabilityReqParams from '../../hooks/chickenDashboard/common/useChickenDashboardAvailabilityReqParams';
import ChickenDashboardContext from '../../contexts/ChickenDashboardContext';

const ChickenDashboardContextProvider = ({ distReqParams, children }) => {
  const intervalReqParams = useChickenDashboardIntervalReqParams(distReqParams);
  const availReqParams = useChickenDashboardAvailabilityReqParams(distReqParams);

  const contextValue = useMemo(() => {
    return { distReqParams, intervalReqParams, availReqParams };
  }, [distReqParams, intervalReqParams]);

  return <ChickenDashboardContext.Provider value={contextValue}>{children}</ChickenDashboardContext.Provider>;
};

export default ChickenDashboardContextProvider;
